<template>
  <div class="page-content" id="ApprovalGoods">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>窜货结算</el-breadcrumb-item>
        <el-breadcrumb-item>窜货审批</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="日期" :label-width="formLabelWidth">
            <el-date-picker v-model="searchformDate" type="daterange" start-placeholder="开始日期" value-format="yyyy-MM-dd"
              end-placeholder="结束日期" range-separator="~" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="提报编号" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.chnumber" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.shopname" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="产品码" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.productcodes" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth">
            <el-select v-model="queryParams.type" filterable clearable placeholder="请选择" size="small">
              <el-option v-for="item in zhuangTaiLIst" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <div class="page">
        <div class="downBtn" style="margin-bottom: 8px;">
          <el-button size="small" type="primary" @click="download" :loading="LoadData">下载数据</el-button>
        </div>
        <el-table :data="tableData" ref="multipleTable" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" @row-click="detailsDrawer" style="width: 100%;">
          <el-table-column label="提报编号" width="140">
            <template slot-scope="scope">
              <div style="width: 126px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.chnumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="店铺名称" prop="shopname">
          </el-table-column>
          <el-table-column label="窜货类型" prop="report_type">
            <template slot-scope="scope">
              <el-button type="success" size="mini" v-if="scope.row.report_type === 'YOUHUO'">有货</el-button>
              <el-button type="warning" plain size="mini" v-else>无货</el-button>
            </template>
          </el-table-column>
          <el-table-column label="提交人" prop="dealername">
          </el-table-column>
          <el-table-column label="提交时间" prop="createtime">
          </el-table-column>
          <el-table-column label="状态" prop="childstatus">
            <template slot-scope="scope">
              <div
                :style="scope.row.childstatus == '待审批' ? 'color: #409eff;' : scope.row.childstatus == '同意' ? 'color: #67c23a;' : 'color: #f56c6c;'">
                {{ scope.row.childstatus }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-show="this.tableData.length > 0">
          <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
            @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          </pagination>
        </div>
      </div>
    </div>
    <el-drawer title="审批详情" :visible.sync="drawer" size="840px"
      custom-class="el-drawer-deal el-drawer-credit  outline_right">
      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">举报信息</span>
      </div>
      <el-card>
        <el-form label-width="150px">
          <el-form-item label="提报编号：">
            {{ detilData.chnumber }}
          </el-form-item>
          <el-form-item label="提交人：">
            <span>{{ dealername }}</span>
          </el-form-item>
          <el-form-item label="手机号：">
            <span>{{ detilData.dealerphone }}</span>
          </el-form-item>
        </el-form>
      </el-card>

      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">渠道信息</span>
      </div>
      <el-card>
        <el-form label-width="150px">
          <el-form-item label="购买渠道：" v-if="detilData.reportType !== 'WUHUO'">
            {{ detilData.purchaseChannels }}
          </el-form-item>
          <el-form-item label="电商平台：" v-if="detilData.platform">
            <span>{{ detilData.platform }}</span>
          </el-form-item>
          <el-form-item label="店铺名称：">
            <span>{{ detilData.shopname }}</span>
          </el-form-item>
          <el-form-item label="门头照片（带水印）：" v-if="detilData.purchaseChannels !== '线上'">
            <div v-if="detilData.entrancePhoto">
              <div v-for="(item) in detilData.entrancePhoto.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="陈列照片（带水印）：" v-if="detilData.purchaseChannels !== '线上'">
            <div v-if="detilData.displayPhoto">
              <div v-for="(item) in detilData.displayPhoto.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-card>

      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">产品信息</span>
      </div>
      <el-card>
        <div class="product-del-card" v-for="(item, index) in listpro">
          <div class="product-del-header">
            <div class="product-del-title">
              产品{{ index + 1 }}
            </div>
            <div class="delete-btnnew" v-if="item.totalPrice != 0">
              ￥{{ item.totalPrice }}
            </div>
          </div>
          <div class="card-div" style="border: none;">
            <el-row>
              <el-col :span="24">
                <div class="card-div" v-if="item.hcmReportInfoProductList.length != 0" style="padding: 5px 0px;">
                  <el-row>
                    <el-col :span="4">
                      <div style="text-align: left;display: flex;flex-flow: row nowrap;color: #7F7F7F;"
                        class="colClass">
                        产品名称
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="colClass">
                        {{ item.productName }}
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <div class="card-div" v-for="(data, num) in item.hcmReportInfoProductList" style="padding: 5px 0px;">
                  <div style="padding: 5px 0px;">
                    <el-row>
                      <el-col :span="4" v-if="detilData.reportType != 'YOUHUO'">
                        <div style="text-align: left;display: flex;flex-flow: row nowrap;color: #7F7F7F;"
                          class="colClass">
                          产品码
                        </div>
                      </el-col>
                      <el-col :span="4" v-if="detilData.reportType == 'YOUHUO'">
                        <div
                          style="text-align: left;text-align: left;display: flex;flex-flow: row nowrap;color: #7F7F7F;"
                          class="colClass" v-if="num == 0">
                          产品码
                        </div>
                        <div
                          style="text-align: left;text-align: left;display: flex;flex-flow: row nowrap;color: #FAFAFA;"
                          class="colClass" v-else>
                          产品码
                        </div>
                      </el-col>
                      <el-col :span="20">
                        <span class="colClass">
                          {{ data.productCodes }}
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                  <div style="padding: 5px 0px;" v-if="data.productCodePhotos">
                    <el-row>
                      <el-col :span="4">
                        <div
                          style="text-align: left;text-align: left;display: flex;flex-flow: row nowrap;color: #7F7F7F;"
                          class="colClass">
                          产品码照片
                        </div>
                      </el-col>
                      <el-col :span="20">
                        <div v-if="data.productCodePhotos">
                          <div v-for="(item) in data.productCodePhotos.split(',')" style="width: 100px;float: left;"
                            @click="jump(item)">
                            <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                            </img>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div style="padding: 5px 0px;"
                  v-if="item.hcmReportInfoProductList.length != 0 && detilData.purchaseChannels == '线上'">
                  <el-row>
                    <el-col :span="4">
                      <div style="text-align: left;text-align: left;display: flex;flex-flow: row nowrap;color: #7F7F7F;"
                        class="colClass">
                        产品链接
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div
                        style="line-height: 45px;cursor: pointer;color: #1a73e8;word-break: break-all;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;"
                        @click="jump(item.purchaseLink)">
                        {{ item.purchaseLink }}
                      </div>
                      <el-tooltip content="复制链接" placement="top">
                        <el-button type="text" icon="el-icon-document-copy" @click="copyLink(item.purchaseLink)"
                          style="padding: 2px 5px;"></el-button>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="total-del-summary">
          <div class="summary-del-title">
            产品汇总
          </div>
          <div class="summary-del-content">
            <div v-for="(n, index) in listpro">
              <div v-if="n.productName && n.hcmReportInfoProductList.length != 0">
                <div style="margin-bottom: 10px;">
                  {{ n.productName }}
                </div>
                <div style="color: #666;margin: 5px 0px 15px 0px;" v-if="n.totalPrice">
                  {{ n.hcmReportInfoProductList.length }}罐/袋 × ¥{{ getMeanValue(n, index) }} =
                  ¥{{ n.totalPrice }}
                </div>
                <div style="color: #666;margin: 5px 0px 15px 0px;" v-else>
                  {{ n.hcmReportInfoProductList.length }}罐/袋
                </div>
              </div>
              <div v-else>
                暂无产品信息
              </div>
            </div>
            <div class="summary-del-total">
              <div>
                总计
              </div>
              <div style="color: #666;" v-if="detilData.reportType !== 'WUHUO'">
                {{ getTotalCans() }}罐/袋， ¥{{ getTotalPrice().toFixed(2) }}
              </div>
              <div style="color: #666;" v-else>
                {{ getTotalCans() }}罐/袋
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">支付信息</span>
      </div>
      <el-card>
        <el-form label-width="150px">
          <el-form-item label="订单截图：" v-if="detilData.purchaseChannels == '线上'">
            <div v-if="detilData.orderScreenshot">
              <div v-for="(item) in detilData.orderScreenshot.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="快递面单：" v-if="detilData.purchaseChannels == '线上'">
            <div v-if="detilData.expressWaybill">
              <div v-for="(item) in detilData.expressWaybill.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="支付凭证：" v-if="detilData.paymentProof">
            <div v-if="detilData.paymentProof">
              <div v-for="(item) in detilData.paymentProof.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="价格标签：" v-if="detilData.reportType == 'WUHUO'">
            <div v-if="detilData.priceTag">
              <div v-for="(item) in detilData.priceTag.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 10px;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="快递费：" v-if="detilData.purchaseChannels == '线上'">
            <span>{{ detilData.expressPrice }}</span>
          </el-form-item>
        </el-form>
      </el-card>

      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">处理进度</span>
      </div>
      <el-card>
        <el-timeline>
          <el-timeline-item v-for="item in hcmReportInfoChild" :timestamp="item.time">
            <div style="padding-bottom: 5px;">
              处理人：{{ item.realname }}
            </div>
            <div style="padding-bottom: 5px;">
              状态：{{ item.status }}
            </div>
            <div style="padding-bottom: 5px;" v-if="item.explain">
              说明：{{ item.explain }}
            </div>
          </el-timeline-item>
        </el-timeline>
      </el-card>

      <div style="padding-bottom: 40px;">
        <div v-if="this.logintype == 'DEALER' && status == '待审批'" style="margin: 20px;">
          <button type="primary" style="background-color: #F56C6C;border-radius: 16px;"
            @click="deleteReportInfoChild()">撤
            回</button>
        </div>

        <div v-if="this.logintype == 'HCM' && status == '待审批' || this.logintype == 'HCMSUB' && status == '待审批'"
          style="margin-top: 20px;text-align: right;">
          <el-button type="primary" @click="subChange('同意')">同 意</el-button>
          <el-button type="danger" @click="subChange('拒绝')">拒 绝</el-button>
        </div>
      </div>
    </el-drawer>

    <el-dialog :title="clickStatus + '审批'" :visible.sync="logShow" width="540px" id="dialog">
      <el-row style="margin: 20px 0;">
        <el-col :span="24">
          <div style="display: flex;height: 32px;line-height: 32px;margin-bottom: 20px;">
            <div style="width: 103px;text-align: right;">
              审批理由
            </div>
            <el-input placeholder="请输入" v-model="explain" clearable style="width: 100%;margin-left: 10px;"
              type="textarea" :rows="3"></el-input>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="saveReportInfoChild(1)">取 消</el-button>
        <el-button @click="saveReportInfoChild(2)" type="primary">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import pagination from "../../components/dataTable/pagination";
export default {
  data() {
    return {
      reportInfoVerification: {},
      queryParams: {
        type: '',
        productcodes: '',
        shopname: '',
        chnumber: '',
      },
      drawer: false,
      dataLoading: false,
      pageNo: 1,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      totalNum: 100,
      formLabelWidth: '100px',
      detilData: {},
      zhuangTaiLIst: [{
        name: '待审批',
        value: '1'
      }, {
        name: '已审批',
        value: '2'
      }],
      dealername: '',
      hcmReportInfoChild: [],
      listpro: [],
      logintype: '',
      status: '',
      clickStatus: '',
      explain: '',
      logShow: false,
      reportid: '',
      LoadData: false,
      searchformDate: [],
    }
  },
  mounted() {
    this.logintype = JSON.parse(localStorage.getItem('userData')).logintype
    console.log(this.logintype)
    this.theQuery()
  },
  methods: {
    // 下载
    download() {
      this.LoadData = true;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.begintime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10) + " 00:00:00"
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10) + " 23:59:00"
      }
      fetch({
        url: "hcm/HcmReportInfo/findReportInfoBmcDownload",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "blob"
      })
        .then((res) => {
          //下载
          this.LoadData = false;
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '窜货审批报表.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    },
    // 详情
    saveReportInfoChild(e) {
      if (e == 1) {
        this.logShow = false;
        return;
      }
      if (!this.explain) {
        this.$message.error("请输入");
        return
      }
      let params = {
        reportinfoid: this.reportid,
        explain: this.explain,
        status: this.clickStatus
      }
      fetch({
        url: "hcm/HcmReportInfo/saveReportInfoChild",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.theQuery();
          this.logShow = false;
          this.drawer = false;
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 点击同意拒绝
    subChange(e) {
      this.logShow = true;
      this.clickStatus = e;
      this.explain = '';
    },
    getTotalCans() {
      let total = 0;
      this.listpro.forEach(n => {
        if (n.hcmReportInfoProductList) {
          total += n.hcmReportInfoProductList.length;
        }
      });
      return total;
    },
    getTotalPrice() {
      let total = 0;
      this.listpro.forEach(n => {
        total += Number(n.totalPrice) || 0;
      });
      return total;
    },
    getMeanValue(n, index) {
      return (Number(n.totalPrice) / Number(n.hcmReportInfoProductList.length)).toFixed(2);
    },
    // 复制链接到剪贴板
    copyLink(link) {
      if (!link) {
        this.$message.warning('链接为空');
        return;
      }

      // 创建临时的textarea元素
      const textArea = document.createElement('textarea');
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('链接已复制到剪贴板');
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textArea);
    },
    // 跳转到链接
    jump(url) {
      if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
        window.open(url);
      } else {
        this.$message.warning('链接格式不正确');
      }
    },
    // 详情
    detailsDrawer(row) {
      this.detilData = {}
      this.reportid = row.id;
      let params = {
        id: row.id
      }
      fetch({
        url: "hcm/HcmReportInfo/findById",
        method: "get",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.detilData = res.data.hcmReportInfo;
          this.hcmReportInfoChild = res.data.hcmReportInfoChild;
          this.listpro = res.data.listpro;
          this.dealername = res.data.dealername;
          this.status = res.data.status
          this.drawer = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = `${val}`
      this.theQuery()
    },
    // 翻页
    handleSizeChange(val) {
      this.pageSize = `${val}`
      this.theQuery()
    },
    // 数据源
    theQuery() {
      this.dataLoading = true
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.begintime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10) + " 00:00:00"
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10) + " 23:59:00"
      }
      fetch({
        url: "hcm/HcmReportInfo/findPageReportInfo",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.dataLoading = false
          this.tableData = res.data.content
          this.totalNum = res.data.totalElements
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(error => {
        this.dataLoading = false
        console.log(error)
      })
    },
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss">
#ApprovalGoods {
  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  .el-table th {
    background-color: #f2f6fe !important;
    color: #4a4b4c;
  }

  .page {
    padding: 20px;
    margin: 10px 0px 0px 0px;
    background-color: white;
  }

  .el-drawer {
    background-color: rgb(240, 242, 245) !important;
  }

  .el-drawer-credit .el-drawer__header {
    background-color: white;
  }

  .product-del-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .product-del-title {
    font-weight: 500;
    color: #1a73e8;
  }

  .delete-btnnew {
    color: #ff4d4f;
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: background 0.3s;
  }

  .colClass {
    height: 45px;
    line-height: 45px;
  }

  .summary-del-title {
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #1a73e8;
  }

  .summary-del-total {
    font-weight: 500;
    border-top: 1px solid #c2e0ff;
    padding-top: 10px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

}
</style>
